import { Fragment } from "react"
import FirearmCard from "../Common/FirearmCard"
import CTABannerV2 from "../Marketing/CTABannerV2"

export default function FirearmGrid({
    items,
    emptyMessage = "No auctions to show.",
}) {
    if (items.length === 0) {
        return <p className="py-10 text-center text-gray-500">{emptyMessage}</p>
    }
    return (
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 xl:grid-cols-3">
            {items.map((item, index) => (
                <Fragment key={item.id}>
                    <FirearmCard data={item} eager={index === 0} />
                    {items.length > 18 && (index + 1) % 18 === 0 && (
                        <div className="col-span-full">
                            <CTABannerV2 scroll={true} />
                        </div>
                    )}
                </Fragment>
            ))}
        </div>
    )
}
